// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4586":"e76a6f71","5619":"22ba6f29","6157":"e76a6f71"}[chunkId] + ".chunk.css";
};